import {useLocation, useNavigate} from 'react-router-dom'
import React, {useEffect} from "react";
import LeftSideMenu from "../components/SideMenu/LeftSideMenu";
import RightSideMenu from "../components/SideMenu/RightSideMenu";
import {useAppSelector} from "../hooks/redux";
import {useDispatch} from "react-redux";
import Cookies from "js-cookie";
import {logIn} from "../store/reducers/AuthSlice";

const RequireAuth = ({children}: { children: JSX.Element }) => {
    const {loggedIn} = useAppSelector(state => state.auth)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const {pathname} = useLocation()

    useEffect(() => {
        if (Cookies.get('access')) {
            dispatch(logIn())
        } else if (!Cookies.get('access') || !loggedIn) {
            navigate('/login')
        }
    }, [dispatch, Cookies.get('access'), loggedIn])

    return (
        <>
            <LeftSideMenu/>
            {children}
            <RightSideMenu pathname={pathname}/>
        </>
    )
}

export default RequireAuth;
